import type { YoungAccidentDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/accident';
import {
    getCoverageTermValue,
    formatAmountWithCurrency
} from '../coverableDetailsInsuranceSumsConfig';
import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';

const getYoungAccidentInsuranceSumsCoverableDetailsConfig = (
    youngCoverable: YoungAccidentDTO
): TableInformation => {
    return {
        title: 'Forsikringssummer',
        rowsInformation: [
            {
                name: 'Varigt mén - erstatningen er en procentdel af forsikringssummen',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCPermanentInjuryToothDamageCov',
                        'ACCPermanentInjuryToothDamageCovSumInsured'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovSumInsured'
                )
            },
            {
                name: 'Erstatningen starter ved méngrad på',
                fieldValue: `${getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovCovPIDegree'
                )}%`,
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovCovPIDegree'
                )
            },
            {
                name: 'Dobbelterstatning',
                fieldValue: `${getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovCompensation'
                )}%`,
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovCompensation'
                )
            },
            {
                name: 'Tandskade',
                fieldValue: 'Efter regning',
                valueType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-ACC-HIGHLIGHTED-TEXT-MODAL-EFTER-REGNING-TITLE',
                        description: 'DSS-ACC-ADULT-YOUNG-HIGHLIGHTED-TEXT-MODAL-EFTER-REGNING'
                    }
                }
            },
            {
                name: 'Udgifter til behandling',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCPermanentInjuryToothDamageCov',
                        'ACCPermanentInjuryToothDamageCovTreatmentCost'
                    ).split('.')[0]
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovTreatmentCost'
                )
            },
            {
                name: 'Skade på briller',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCPermanentInjuryToothDamageCov',
                        'ACCPermanentInjuryToothDamageCovGlasses'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCPermanentInjuryToothDamageCov',
                    'ACCPermanentInjuryToothDamageCovGlasses'
                )
            },
            {
                name: 'Udbetaling ved enkelt brud eller overrivning',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCImmediateCompensationCov',
                        'ACCImmComCov1fracTopTerm'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCImmediateCompensationCov',
                    'ACCImmComCov1fracTopTerm'
                )
            },
            {
                name: 'Udbetaling ved flere samtidige brud eller overrivninger',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCImmediateCompensationCov',
                        'ACCImmComCovMultiTopTerm'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCImmediateCompensationCov',
                    'ACCImmComCovMultiTopTerm'
                )
            },
            {
                name: 'Varigt mén ved ulykke i forbindelse med farlig sport - erstatningen er en procentdel af forsikringssummen',
                fieldValue: formatAmountWithCurrency(
                    getCoverageTermValue(
                        youngCoverable,
                        'ACCHighRiskSportCov',
                        'ACCHighRiskSportCovHighRiskSportCovDisabilitCovTerm'
                    )
                ),
                valueType: 'amount',
                hidden: !getCoverageTermValue(
                    youngCoverable,
                    'ACCHighRiskSportCov',
                    'ACCHighRiskSportCovHighRiskSportCovDisabilitCovTerm'
                )
            }
        ]
    };
};

export { getYoungAccidentInsuranceSumsCoverableDetailsConfig };
